import React,{useState} from "react";
import './cartWidget.css';
import Content from './Animacion/Content';
import Sidebar from './Animacion/Sidebar';
import SidebarWish from "./Animacion/SidebarWish";

//ejecuta cada componente de la animacion tanto del carrito como de wishList
function CartWidget() {
  const [sideBar, setSideBar] = useState(false);
  const [sideBarWish, setSideBarWish] = useState(false);

  
  return (
    <div className="container mx-auto p-8">
      <Content {...{ sideBar, setSideBar, sideBarWish,setSideBarWish}} />
      <Sidebar {...{ sideBar, setSideBar}} />
      <SidebarWish {...{sideBarWish, setSideBarWish}}/>
    </div>
  );
}
export default CartWidget;       